<template>
	<section
	ref="sectionCategories"
	class="card d-flex overflow-x"
	:style="categoriesCss"
	style="height: 50px;"
	>
		<div
		v-for="(item) in menuCategorias"
		:key="item.id"
		@click="navegar(item.id) "
		:ref="item.id"
		class="card--content d-flex align-center justify-center px-4 noSelectableText mb-n1"
		style="height: 48px;"
		>
			<span class="font-weight-bold body-2 decoration-none noSelectableText">{{ item.nombre }}</span>
		</div>

		<v-divider></v-divider>
	</section>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
	name: "navCategoriasMovil",
	components: {

	},
	data() {
		return {
			categoriesCss: { "max-width": 100, "margin-left": 0 }
		};
	},
	computed: {
		...mapState({
			isSafari: state => state.app.isSafari,
		}),
		...mapGetters({
			filtradoProductosRestaurante: "restaurante/filtradoProductosRestaurante"
			// esDomicilio: "pedido/esDomicilio"
		}),
		menuCategorias: function() {
			let result = this.filtradoProductosRestaurante.filter(
				e => e.productos.length > 0
			);

			return result;
		}
	},
	methods: {
		navegar(id) {
			let _vue = this;
			let duration = _vue.isSafari ? 0 : 500;
			let offset = _vue.$vuetify.breakpoint.smAndDown ? 50 : 0;

			_vue.$vuetify.goTo("#" + id, {
				duration: duration,
				offset: offset,
				easing: "easeOutQuad"
			});
		},
	},
	beforeMount() {},
	mounted() {
	
	}
};
</script>

<style scoped>
/* Navbar categorias */
.card {
  background-color: #fff;
  min-width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.card::-webkit-scrollbar {
  display: none;
}
.card--content {
  white-space: nowrap;
  width: auto !important;
  text-transform: initial;
  cursor: pointer;
}
.slider-wrapper {
  width: 100px;
  height: 2px;
  background-color: #4caf50;
  border: 1px solid #4caf50;
  position: absolute;
  bottom: 0px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.decoration-none {
  text-decoration: none;
}

.noSelectableText {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}
.border{
	border: 1px solid #000;
}
</style>